<style>
    .slide-fade-enter-active {
        transition: all 0.5s ease;
    }

    .slide-fade-leave-active {
        transition: all 0.5s ease;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        height: 0;
    }
</style>

<template>

    <div class="fixed pin-x pin-b z-10" :class="{'bg-purple-lightest': isEmpty, 'bg-purple-lighter': !isEmpty}">

        <div class="">

            <div v-show="isEmpty" class="p-4 h-16 text-grey-dark">

                <div class="container mx-auto flex justify-center">

                    <div><i class="fa fa-shopping-cart"></i> add time series to the selection</div>

                </div>

            </div>

            <div v-show="!isEmpty" class="p-4 text-black flex items-center">

                <div class="w-full container mx-auto flex justify-between ">

                    <div class="">
                        <a class="cursor-pointer hover:text-red" @click="removeAll()">
                            <i class="fa fa-fw fa-trash-o"></i>
                            remove all
                        </a>
                    </div>

                    <div class="flex flex-col">
                        <div>{{ report.selected.length }} Series Selected</div>
                        <div class="pt-4 mx-auto text-xl">
                            <a class="cursor-pointer hover:text-white" @click="open = !open">
                                <i class="fa fa-fw" :class="{'fa-chevron-up':open, 'fa-chevron-down':!open}"></i>
                            </a>
                        </div>
                    </div>

                    <div>
                        <a v-show="!loading" @click="submit()"
                           class="shadow cursor-pointer bg-blue-dark text-white p-2 rounded">
                            Show Selection
                        </a>
                        <span v-show="loading">loading...</span>
                    </div>
                </div>

            </div>

            <transition name="slide-fade">
                <div v-show="open" class="bg-grey-lightest overflow-y-auto h-64">
                    <div>
                        <ul class="list-reset">
                            <li class="border-b " v-for="item in report.selected">
                                <a class="p-4 block cursor-pointer hover:bg-red-lighter" @click="remove(item)">
                                    <i class="fa fa-trash-o fa-fw"></i>
                                    <span class="pl-4">{{ item.description.en }}</span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </transition>

            <div v-show="false" class="border-t bg-grey-lightest flex items-center rounded-b-lg h-16 px-4">

                <div class="w-full text-center">
                    <form action="/en/dashboards" method="post" ref="form">
                        <input type="hidden" name="_token" :value="csrf">
                        <input type="hidden" name="series" :value="dashboard">
                        <input type="hidden" name="dashboard" value="true">
                        <input type="submit" value="Show Series" class="p-2">
                    </form>
                </div>

            </div>
        </div>
    </div>

</template>

<script>

    export default {

        inject: ['report'],

        data() {
            return {
                open: false,
                loading: false,
            };
        },

        computed: {
            csrf: function () {
                return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
            },
            dashboard: function () {
                return this.report.selected.map(function (item) {
                    return item.id;
                }).join(',');
            },
            isEmpty: function () {
                return this.report.selected.length === 0;
            }
        },

        methods: {
            submit: function () {
                this.loading = true;
                this.$refs.form.submit();
            },
            remove: function (remove) {
                this.report.selected = this.report.selected.filter(function (item) {
                    return item !== remove;
                });

                if (this.report.selected.length === 0) {
                    this.open = false;
                }
            },
            removeAll: function () {
                this.report.selected = [];
                this.open = false;
            },
        },
    }

</script>